<template>
    <div class="pa-0 ma-0">
        <v-row v-if="selectedFile" class="ma-0 pa-0">
            <v-col class="d-flex flex justify-center py-0">
                <canvas width="0" ref="canvas" style="display: none;"></canvas>
            </v-col>
            <v-col cols="12" md="12" class="d-flex flex-column justify-center align-center">
                <v-btn @click="enviarFoto" color="primary" elevation="0" class="pa-5" width="163">
                    <v-icon class="mr-2">mdi-check</v-icon>
                    ACEPTAR
                </v-btn>
                <v-btn @click="descartar" outlined color="secondary" elevation="0" class="mt-1 pa-5" width="163">
                    <v-icon class="mr-2">mdi-delete-outline</v-icon>
                    DESCARTAR
                </v-btn>
            </v-col>
        </v-row>
        <div class="d-flex flex-row justify-center align-center pb-5">
            <v-btn v-if="!selectedFile" color="primary" elevation='0' class="mt-1 pa-5" :loading="loading"
                :width="width" @click="handleFileImport">
                <v-icon class="mr-2">{{ icono }}</v-icon>
                {{ titulo }}
            </v-btn>
            <input ref="uploader" class="d-none" type="file" accept="image/jpg, image/jpeg" @change="onFileChanged">
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'InputButton',
    data() {
        return {
            isSelecting: false,
            selectedFile: null,
            visible: true,
            subida: false,
            almacenado: false,
            loading: false,

            fotoString: '',
        }
    },
    methods:
    {
        ...mapActions('dataUser', ['precargaFoto', 'subirFotoPerfil', 'guardarFotoCarnet', 'precargaFotoCarnet']),
        ...mapActions('auth', ['validarImagen']),
        ...mapActions('preafiliacion', ['addFotoCarnet', 'guardarPreFotoCarnet']),

        enviarFoto() {
            if (this.tipo == 'fotoperfil') {
                this.selectedFile = null
                this.subirFotoPerfil({ nroafi: this.nroafi, fotoperfil: this.fototmp })
            } else if (this.tipo == 'fotocarnet') {
                if (this.isAuthenticated) {
                    this.guardarFotoCarnet()
                } else {
                    this.guardarPreFotoCarnet()
                    this.addFotoCarnet('')
                }
            }
            this.$emit("fotoCargada")
            this.selectedFile = null
            //vacio fototmp
            this.precargaFoto('')
            //this.subirFotoCarnet({ nroafi: this.nroafi, fotocarnet: this.fototmp })

        },
        descartar() {
            if (this.tipo == 'fotoperfil') {
                this.precargaFoto('')
            } else if (this.tipo == 'fotocarnet') {
                if (this.isAuthenticated) {
                    this.precargaFotoCarnet('')
                    this.precargaFoto('')
                } else {
                    this.addFotoCarnet('')
                }
            }
            this.selectedFile = null
            this.subida = false
        },
        handleFileImport() {
            this.isSelecting = true;

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {
                this.isSelecting = false
            }
        },

        async onFileChanged(e) {
            //validar si la imagen es oscura
            const formData = new FormData()
            formData.append('selfie', e.target.files[0])
            formData.append('minBrightness', 50)
            formData.append('maxBrightness', 200)
            const valido = (this.tipo == 'fotoperfil') ? true : await this.validarImagen(formData)
            if (e.target.files[0] && valido) {
                this.selectedFile = e.target.files[0]
                //this.$emit('fotoCargada')
                //this.precargaFoto(this.selectedFile)

                //envio señal de fotoSeleccionada
                //this.$emit('haySeleccion')
                const reader = new FileReader();
                reader.onloadend = () => {
                    //referencia al elemento canvas
                    let canvas = this.$refs.canvas
                    //config
                    const ctx = canvas.getContext('2d');

                    const vm = this

                    //nueva imagen
                    const img = new Image

                    img.src = URL.createObjectURL(this.selectedFile)
                    img.onload = function () {
                        const targetWidth = 278;
                        const targetHeight = 278;
                        let newWidth, newHeight;
                        if (img.width / img.height > targetWidth / targetHeight) {
                            newWidth = img.width * (targetHeight / img.height);
                            newHeight = targetHeight;
                        } else {
                            newWidth = targetWidth;
                            newHeight = img.height * (targetWidth / img.width);
                        }
                        // Calcula los desplazamientos para recortar desde el centro
                        const offsetX = (newWidth - targetWidth) / 2;
                        const offsetY = (newHeight - targetHeight) / 2;
                        // Asigna las nuevas dimensiones al canvas
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;

                        ctx.clearRect(0, 0, canvas.width, canvas.height)
                        ctx.drawImage(img, -offsetX, -offsetY, newWidth, newHeight);


                        let dataURL = canvas.toDataURL('image/png');
                        const arr = dataURL.split(',');
                        //seguir aca, subir donde corresponda la fototmp
                        if (vm.isAuthenticated) {
                            vm.precargaFoto(arr[1])
                            //vm.$emit('fotoCargada')
                        } else {
                            //revisar
                            vm.addFotoCarnet(arr[1])
                        }
                    }
                };
                reader.readAsDataURL(this.selectedFile)
            }
            /*             if (this.isAuthenticated) {
                            this.precargaFoto(this.fotoString)
                        } else {
                            //revisar
                            this.addFotoCarnet(this.fotoString)
                        } */
        },
    },
    computed: {
        ...mapGetters('auth', ['nroafi', 'isAuthenticated']),
        ...mapGetters('dataUser', ['fototmp', 'fototmpcarnet']),
        // ...mapGetters('preafiliacion', ['fototmp']),
    },
    props: {
        titulo: {
            type: String,
            required: true
        },
        icono: {
            type: String,
            required: true
        },
        tipo: {
            type: String,
            required: false
        },
        width: {
            type: Number,
            required: false
        }
    }
}
</script>